// Scripts for the featured video module
document.addEventListener("DOMContentLoaded", function () {
    const featuredVideo = document.querySelector("#featured-video-preview");
    const featuredVideoClose = document.querySelector("#featured-video-close");
    const featuredVideoEmbed = document.querySelector(
        ".o-featuredVideo__embed iframe"
    );

    if (featuredVideo) {
        featuredVideo.addEventListener("click", function () {
            document.querySelector("#featured-video-dialog").showModal();
        });
        featuredVideoClose.addEventListener("click", function () {
            const featuredVideoSrc = featuredVideoEmbed.src;
            featuredVideoEmbed.src = featuredVideoSrc;
            document.querySelector("#featured-video-dialog").close();
        });
    }
});
